<template>
  <b-modal
    ref="addChartModal"
    hide-footer
    centered
    title="Create new Chart"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Default chart type:"
        >
        <b-form-select
          v-model="defaultChartType"
          :options="chartTypes"
        />
      </b-form-group>
      <b-form-group
        label="Chart id:"
        >
        <b-form-input
          type="text"
          v-model.trim="chartId"
          autocomplete="off"
          />
      </b-form-group>
      <b-form-group
        label="Data expression:"
        >
        <b-form-input
          type="text"
          v-model.trim="dataExp"
          autocomplete="off"
          />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      defaultChartType: null,
      chartTypes: [
        { value: 'pie', text: 'Pie' },
        { value: 'bar', text: 'Bar' },
        { value: 'donut', text: 'Donut' },
        { value: 'stacked', text: 'Stacked' },
        { value: 'line', text: 'Line' }
      ],
      chartId: '',
      dataExp: '',
    }
  },
  computed: {
    ...mapState([
      'currentTab'
    ])
  },
  methods: {
    async save () {
      const vm = this
      const data = {
        defaultChartType: vm.defaultChartType,
        chartId: vm.chartId,
        dataExp: vm.dataExp,
        tab: vm.currentTab
      }

      await db.chart.add(data)

      this.defaultChartType = null
      this.chartId = ''
      this.dataExp = ''

      if (this.$refs.addChartModal) this.$refs.addChartModal.hide()
    }
  },
  created () {
    eventBus.$on('showAddChartModal', () => {
      if (this.$refs.addChartModal) this.$refs.addChartModal.show()
    })
  },
  mounted () {
    if (this.$refs.addChartModal) {
      $(this.$refs.addChartModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addChartModal) {
      $(this.$refs.addChartModal['$el']).remove()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Modals/AddChart.vue